import React, { useState, useEffect } from "react";
import axios from "axios";
import { DatePicker, Select, InputNumber } from "antd";
import { isEmpty, sortBy } from "lodash";
import { fetchDistinctUsersFullname } from "./../../../modules/presence/api/api";
import GenerateTransferOrder from "../../../components/generateTransferOrder/GenerateTransferOrder";
const baseapi = process.env.REACT_APP_API + "/api";
const Option = Select.Option;

const TransfersFilters = ({
  selectedUserName,
  setSelectedUserName,
  userSelectedIds = null,
  handleTransferOrderGenerated,
  token,
  userRoleId,
  setSelectedCompanyId,
  setSelectedStatus,
  selectedBankStatus,
  setSelectedBankStatus,
  selectedCompanyLabel,
  setSelectedCompanyLabel,
  selectedTransferId,
  setSelectedTransferId,
  dateSelected,
  setSelectedDate,
  menuItem,
  selectedCompanyId,
  data
}) => {
  const [usersOptions, setUsersOptions] = useState([]);

  const getStatusList = () => {
    if (data && !isEmpty(data)) {
      if (menuItem === "details")
        return data.reduce((acc, item) => {
          const newItem = {
            id: item.transfer.status.id,
            label: item.transfer.status.label
          };
          if (!acc.find(item => item.id === newItem.id)) acc.push(newItem);
          return acc;
        }, []);
      return data.reduce((acc, item) => {
        const newItem = {
          id: item.status.id,
          label: item.status.label
        };
        if (!acc.find(item => item.id === newItem.id)) acc.push(newItem);
        return acc;
      }, []);
    }
    return [];
  };

  useEffect(() => {
    fetchDistinctUsersFullname(token).then(response => {
      setUsersOptions(response);
    });
  }, []);

  const getCompanyList = () =>
    data && !isEmpty(data)
      ? data.reduce((acc, item) => {
          const companyData = {
            label:
              menuItem === "bank"
                ? item.company_label
                : item.user_portail2_nomEntreprise
                ? item.user_portail2_nomEntreprise
                : item.user_company_label,
            id: menuItem === "bank" ? item.company_id : item.user_company_id
          };

          if (!acc.find(item => item.id === companyData.id) && companyData.label) acc.push(companyData);
          return acc;
        }, [])
      : [];

  const getTransferOrderParams = () => {
    const paramsToSend = {
      company_id: selectedCompanyId
    };

    if (userSelectedIds) paramsToSend.user_ids = userSelectedIds;
    return paramsToSend;
  };

  const onChangeUserSelected = value => {
    if (value) setSelectedUserName(value);
    else setSelectedUserName(null);
  };

  return (
    <div className="my-8 flex items-center">
      {(menuItem === "bank" || menuItem === "details") && (
        <React.Fragment>
          <div className="mr-4 text-lg">
            {menuItem === "details" ? "Date de création" : "Date de validation comptable"} :
          </div>
          <DatePicker
            onChange={selectedRangeDate => {
              setSelectedDate(selectedRangeDate);
            }}
            defaultValue={dateSelected}
            format={"DD/MM/YYYY"}
          />
        </React.Fragment>
      )}

      {(menuItem === "employee" || menuItem === "company") && (
        <div className="mx-2">
          <Select
            allowClear
            placeholder="Entreprise"
            style={{ width: 200 }}
            onChange={company => {
              if (company) {
                setSelectedCompanyId(company);
              } else setSelectedCompanyId(null);
            }}
          >
            {!isEmpty(data) &&
              sortBy(getCompanyList(), item => item.label).map(companyItem => (
                <Option key={companyItem.id} value={companyItem.id}>
                  {companyItem.label}
                </Option>
              ))}
          </Select>
        </div>
      )}
      {(menuItem === "employee" || menuItem === "company") && (
        <div className="mx-2">
          <Select
            allowClear
            placeholder="Nom"
            showSearch
            style={{ width: 200 }}
            onChange={value => onChangeUserSelected(value)}
          >
            {usersOptions.map(userName => (
              <Option key={userName} value={userName}>
                {userName}
              </Option>
            ))}
          </Select>
        </div>
      )}
      {(menuItem === "employee" || menuItem === "company") && (
        <div className="mx-2">
          <Select
            allowClear
            placeholder="Statut"
            style={{ width: 200 }}
            onChange={status => (status ? setSelectedStatus(status) : setSelectedStatus(null))}
          >
            {!isEmpty(data) &&
              getStatusList()
                .sort()
                .map(status => (
                  <Option key={status.id} value={status.id}>
                    {status.label}
                  </Option>
                ))}
          </Select>
        </div>
      )}
      {menuItem === "bank" && (
        <div>
          <Filter
            selectedItem={selectedCompanyLabel}
            fetchDistinct={fetchDistinctTransfers}
            item={"company_label"}
            placeholder={"Entreprise"}
            onChange={setSelectedCompanyLabel}
            token={token}
          />
          <Filter
            selectedItem={selectedBankStatus}
            fetchDistinct={fetchDistinctTransfers}
            item={"status.label"}
            placeholder={"Statut"}
            onChange={setSelectedBankStatus}
            token={token}
          />
          <Filter
            selectedItem={selectedTransferId}
            fetchDistinct={fetchDistinctTransfers}
            item={"id"}
            placeholder={"N° de transfert"}
            onChange={setSelectedTransferId}
            token={token}
          />
        </div>
      )}
      {menuItem === "details" && (
        <div>
          <Filter
            selectedItem={selectedCompanyLabel}
            fetchDistinct={fetchDistinctTransfersDetails}
            item={"user_company_label"}
            placeholder={"Entreprise"}
            onChange={setSelectedCompanyLabel}
            token={token}
          />
          <Filter
            selectedItem={selectedUserName}
            fetchDistinct={fetchDistinctTransfersDetails}
            item={"user_fullname"}
            placeholder={"Nom"}
            onChange={setSelectedUserName}
            token={token}
          />
          <Filter
            selectedItem={selectedBankStatus}
            fetchDistinct={fetchDistinctTransfersDetails}
            item={"transfer.status.label"}
            placeholder={"Statut"}
            onChange={setSelectedBankStatus}
            token={token}
          />
          <Filter
            selectedItem={selectedTransferId}
            fetchDistinct={fetchDistinctTransfersDetails}
            item={"transfer.id"}
            placeholder={"N° de transfert"}
            onChange={setSelectedTransferId}
            token={token}
          />
        </div>
      )}
      {userRoleId <= 2 && selectedCompanyId && menuItem === "company" && (
        <GenerateTransferOrder
          userSelectedIds={userSelectedIds}
          handleTransferOrderGenerated={handleTransferOrderGenerated}
          token={token}
          params={getTransferOrderParams()}
        />
      )}
    </div>
  );
};

export default TransfersFilters;

const Filter = ({ item, selectedItem, fetchDistinct, onChange, placeholder, token, width }) => {
  const [items, setItems] = useState([]);
  return (
    <Select
      allowClear={true}
      showSearch
      placeholder={placeholder}
      style={{ width: width || 200, margin: 5 }}
      value={selectedItem}
      onFocus={async () => {
        const response = await fetchDistinct(item, token);
        setItems(response);
      }}
      onChange={onChange}
    >
      {items.map(elem => (
        <Option key={elem} value={elem}>
          {elem}
        </Option>
      ))}
    </Select>
  );
};

const fetchDistinctTransfers = async (item, token) => {
  return axios
    .post(
      `${baseapi}/transfers/distincts/${item}`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

const fetchDistinctTransfersDetails = async (item, token) => {
  return axios
    .post(
      `${baseapi}/transfers_details/distincts/${item}`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};



// WEBPACK FOOTER //
// src/modules/presence/transfers/TransfersFilters.js